<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="1100"
        content-class="doll-viewer-dialog"
    >
        <!-- Modern Header -->
        <div class="viewer-header">
            <div class="header-left">
                <v-icon color="white" size="28">mdi-package-variant-closed</v-icon>
                <span class="header-title">{{ "Información - " + LncName }}</span>
            </div>
            <v-btn icon dark @click="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>

        <!-- Body -->
        <div class="viewer-body">
            <v-stepper v-model="stageTransfer" class="elevation-0 viewer-stepper">
                <v-stepper-header class="stepper-header-compact">
                    <v-stepper-step
                        :complete="stageTransfer > 1"
                        step="1"
                        color="primary"
                        editable
                    >
                        {{ "Información - " + LncName }}
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                        :complete="stageTransfer > 2"
                        step="2"
                        color="primary"
                    >
                        Mesas
                    </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <!-- Step 1: Dolls Viewer -->
                    <v-stepper-content step="1" class="stepper-content-compact">
                        <!-- Section Title -->
                        <div class="section-title-bar">
                            <div class="title-left">
                                <v-icon small color="primary">mdi-package-variant</v-icon>
                                <span class="section-label">{{ "Muñecos en proceso" }}</span>
                                <v-chip
                                    v-if="dolls.length > 0"
                                    x-small
                                    color="primary"
                                    class="ml-2 count-chip"
                                >
                                    Muñecos: {{ dolls.length }}
                                </v-chip>
                                <v-chip
                                    v-if="dolls.length > 0"
                                    x-small
                                    color="success"
                                    class="ml-2 count-chip"
                                >
                                    Total Jabas: {{ totalJabasInProcess }}
                                </v-chip>
                            </div>
                            <v-btn
                                v-if="dollTransfer > 0"
                                fab
                                x-small
                                color="primary"
                                elevation="2"
                                @click="stageTransfer = 2"
                            >
                                <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                        </div>

                        <!-- Dolls Horizontal Scroll -->
                        <div class="dolls-scroll-container">
                            <!-- Left Arrow -->
                            <button
                                class="scroll-arrow scroll-arrow-left"
                                :class="{ 'arrow-edge': !canScrollLeft }"
                                @click="scrollDolls(-1)"
                            >
                                <v-icon>mdi-chevron-left</v-icon>
                            </button>

                            <!-- Scrollable Track -->
                            <div
                                class="dolls-scroll-track"
                                ref="dollsTrack"
                                @scroll="updateArrows"
                            >
                                <div
                                    v-for="jaba in dolls"
                                    :key="jaba.DlpID"
                                    class="doll-slide-item"
                                >
                                    <v-card
                                        class="doll-card"
                                        :class="{ 'doll-selected': dollTransfer === jaba.DlpID }"
                                        width="170"
                                        elevation="3"
                                        @click="dollTransfer = jaba.DlpID"
                                    >
                                        <!-- Selection indicator + ID -->
                                        <div class="doll-card-top">
                                            <v-radio-group
                                                v-model="dollTransfer"
                                                :value="jaba.DlpID"
                                                hide-details
                                                class="doll-radio"
                                                @click.stop
                                            >
                                                <v-radio
                                                    :value="jaba.DlpID"
                                                    color="primary"
                                                ></v-radio>
                                            </v-radio-group>
                                            <span class="doll-id-badge">#{{ jaba.DlpID }}</span>
                                        </div>

                                        <!-- Image -->
                                        <div class="doll-image-wrapper">
                                            <v-img
                                                style="mix-blend-mode: multiply;"
                                                src="./../../../../public/static/jabamuneco.jpg"
                                                height="105"
                                                contain
                                                class="doll-image"
                                            ></v-img>
                                        </div>

                                        <!-- Info chips -->
                                        <div class="doll-info">
                                            <div class="info-row">
                                                <v-icon x-small color="blue-grey">mdi-package-variant</v-icon>
                                                <span class="info-value">{{ jaba.DlpQuantity }} jabas</span>
                                            </div>
                                            <div class="info-row">
                                                <v-icon x-small color="blue-grey">mdi-pallet</v-icon>
                                                <span class="info-value">Pallet {{ jaba.LlpID }}</span>
                                            </div>
                                            <div class="info-row">
                                                <v-icon x-small color="blue-grey">mdi-calendar-text</v-icon>
                                                <span class="info-value">{{ jaba.DlpJuliano }}</span>
                                            </div>
                                            <div class="info-row">
                                                <v-icon x-small color="blue-grey">mdi-tag-text</v-icon>
                                                <span class="info-value info-category">{{ jaba.TypeSelectionFrozenName }}</span>
                                            </div>
                                            <div class="info-row">
                                                <v-icon x-small color="blue-grey">mdi-clock-outline</v-icon>
                                                <span class="info-value">Periodo: P-{{ jaba.PchPeriodo || jaba.PchID || '-' }}</span>
                                            </div>
                                        </div>

                                        <!-- Code badge -->
                                        <div class="doll-card-footer">
                                            <v-chip
                                                x-small
                                                color="error"
                                                text-color="white"
                                                label
                                            >
                                                {{ jaba.DlpCodBase }}
                                            </v-chip>
                                            <v-chip
                                                x-small
                                                color="success"
                                                text-color="white"
                                                label
                                                class="ml-1"
                                            >
                                                P-{{ jaba.PchPeriodo || jaba.PchID || '-' }}
                                            </v-chip>
                                        </div>
                                    </v-card>
                                </div>
                            </div>

                            <!-- Right Arrow -->
                            <button
                                class="scroll-arrow scroll-arrow-right"
                                :class="{ 'arrow-edge': !canScrollRight }"
                                @click="scrollDolls(1)"
                            >
                                <v-icon>mdi-chevron-right</v-icon>
                            </button>
                        </div>

                        <!-- Actions -->
                        <div class="viewer-actions">
                            <v-btn
                                color="grey"
                                text
                                @click="CloseDialogInfoTable()"
                            >
                                <v-icon left small>mdi-cancel</v-icon>
                                Cancelar
                            </v-btn>
                        </div>
                    </v-stepper-content>

                    <!-- Step 2: Transfer -->
                    <v-stepper-content step="2" class="stepper-content-compact">
                        <v-card flat class="d-flex flex-column" style="max-height: calc(85vh - 140px);">
                            <v-card-text class="pa-2 flex-grow-1 overflow-y-auto" style="max-height: calc(85vh - 200px);">
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <s-text
                                            label="Cantidad jabas"
                                            number
                                            v-model="QuantityJabasTransfer"
                                            :min="1"
                                            :max="10000"
                                        ></s-text>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <s-text
                                            label="Numero de Base"
                                            number
                                            v-model="itemHead.DlpCodBase"
                                            ref="txtDlpCodBase"
                                            :min="1"
                                            v-if="mDlpCodBase"
                                        ></s-text>
                                    </v-col>
                                </v-row>
                                <v-row v-if="ItemSelect == 'Store'">
                                    <v-col cols="12">
                                        <s-select-definition
                                            label="Tipo de descarte"
                                            :def="1440"
                                            v-model="itemObservation.DlpTypeDiscard"
                                        ></s-select-definition>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-tabs v-model="ItemSelect">
                                            <v-tab href="#Lines">Líneas</v-tab>
                                            <v-tab href="#Store">Almacén</v-tab>
                                            <v-tab href="#TransferDiscard" v-if="selectDiscard">
                                                Descarte
                                            </v-tab>
                                        </v-tabs>
                                        <v-tabs-items v-model="ItemSelect" class="overflow-y-auto" style="max-height: calc(85vh - 320px);">
                                            <v-tab-item :value="'Lines'">
                                                <tables-line
                                                    v-if="refreshTabs"
                                                    :filter="filter"
                                                    style="margin-top: 15px;"
                                                    @emitTable="emitTable($event)"
                                                ></tables-line>
                                            </v-tab-item>
                                            <v-tab-item :value="'Store'">
                                                <send-doll
                                                    :DlpTypeDiscard="itemObservation.DlpTypeDiscard"
                                                    v-if="refreshTabs"
                                                    @emitLocation="emitLocation($event)"
                                                    @emitInvalidSelection="clearSelection"
                                                >
                                                </send-doll>
                                            </v-tab-item>
                                            <v-tab-item :value="'TransferDiscard'">
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-card outlined class="pa-3 grey lighten-5">
                                                                <v-card-title class="text-h6 pb-2">
                                                                    <v-icon color="info" class="mr-2">mdi-information-outline</v-icon>
                                                                    Resumen de la transferencia
                                                                </v-card-title>
                                                                <v-divider class="mb-3"></v-divider>
                                                                <v-row no-gutters>
                                                                    <v-col cols="6">
                                                                        <div class="text-subtitle-2 grey--text">Cantidad de jabas:</div>
                                                                        <div class="text-h6 primary--text">{{ QuantityJabasTransfer }}</div>
                                                                    </v-col>
                                                                    <v-col cols="6">
                                                                        <div class="text-subtitle-2 grey--text">Destino:</div>
                                                                        <div class="text-h6 error--text">Descarte</div>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions class="pa-2 flex-shrink-0 white">
                                <v-btn color="grey" @click="stageTransfer = 1" dark>
                                    <v-icon left>mdi-cancel</v-icon>
                                    Cancelar
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="success" @click="DollTransferAction()">
                                    <v-icon left>mdi-check</v-icon>
                                    Guardar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </div>
    </v-dialog>
</template>

<script>
    import _dollTableService from "@/services/FrozenProduction/FrzDollTableService.js";
    import SendDoll from '../ArmedDoll/SendDollNew.vue';
    import TablesLine from '@/components/FrozenProduction/Aconditionado/TablesLine.vue';
    import _armedDoolService from '@/services/FrozenProduction/ArmedDollService';
    import _sFrzSelectionGreen from "@/services/FrozenProduction/FrzSelectionGreen";

    export default {
        props: {
            dolls: {
                type: Array,
                default: null
            },
            LncName: {
                type: String,
                default: ""
            },
            IsTransfer: {
                type: Number,
                default: 1
            },
            filter: {
                type: Object,
                dafult: null
            },
            mDlpCodBase:{ default :false },
        },
        components: {
            TablesLine, SendDoll
        },

        data() {
            return {
                dialog: true,
                canScrollLeft: false,
                canScrollRight: false,
                selectGreen: true,
                selectDiscard: false,
                refreshTabs: true,
                stageTransfer: 1,
                showMore: false,
                headerDoll : [
                    {text: "ID", value: "DlpID"},
                    {text: "N° Pallet", value:"LlpID"},
                    {text: "Juliano", value: "DtbJuliano"},
                    {text: "Jabas", value: "DlpQuantity"},
                    {text: "Categoria", value: "TypeFrozenCategoryName"},
                    {text: "Seleccion", value: "TypeSelectionFrozenName"},
                    {text: "Periodo", value: "PchPeriodo"},
                ],
                dollTransfer: 0,
                dollSelectTransfer: {},
                QuantityJabasTransfer: 0,
                tableSelect: {},
                detailsDoll:[],
                itemHead: {},
                itemObservation: {
                    DlpTypeDiscard: 3,
                    DlpWeight: 0
                },
                ItemSelect: "tab-Funciones",
                componentKey: 0,
                TypeSend: 0
            }
        },

        watch: {
            stageTransfer() {
                if(this.stageTransfer == 2)
                {
                    this.dollSelectTransfer = this.dolls.find(element => element.DlpID == this.dollTransfer);
                    if(this.dollSelectTransfer != null)
                    {
                        this.QuantityJabasTransfer = this.dollSelectTransfer.DlpQuantity;
                        this.itemHead.DlpCodBase = this.dollSelectTransfer.DlpCodBase;
                    }
                }
            },
            ItemSelect(val) {
                console.log('val', val);
                this.resetSelect();
                if(val == "Store"){
                    if(this.dolls && this.dolls.length > 0){
                        this.itemObservation.DlpTypeDiscard = this.dolls[0].DlpTypeDiscard || 3;
                    }
                }

                if(val == "SelectGreen"){
                    this.TypeSend = 3;
                }
                else if(val == "TransferDiscard"){
                    console.log('val SelectDiscard', val);
                    this.TypeSend = 4;
                }
            },
            dolls: {
                handler() {
                    this.$nextTick(() => {
                        this.updateArrows();
                    });
                },
                immediate: true
            }
        },

        computed: {
            totalJabasInProcess() {
                if (!this.dolls) return 0;
                return this.dolls.reduce((sum, item) => sum + (Number(item.DlpQuantity) || 0), 0);
            }
        },

        methods: {
            closeDialog() {
                this.dialog = false;
                this.$emit("CloseDialogInfoTable");
            },
            scrollDolls(direction) {
                const track = this.$refs.dollsTrack;
                if (!track) return;
                const scrollAmount = 200;
                track.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
                setTimeout(() => this.updateArrows(), 350);
            },
            updateArrows() {
                const track = this.$refs.dollsTrack;
                if (!track) return;
                this.canScrollLeft = track.scrollLeft > 2;
                this.canScrollRight = track.scrollLeft < (track.scrollWidth - track.clientWidth - 2);
            },
            emitTable(table)
            {
                this.tableSelect = table;
                this.TypeSend = 1;
            },
            emitLocation(Location){
                this.TypeSend = 2;
                console.log('emitLocation', this.TypeSend, this.dollTransfer);
                this.tableSelect = Location;
                this.dollSelectTransfer.DlpCol = this.tableSelect.item.DedDescription;
                this.dollSelectTransfer.DlpRow = this.tableSelect.item2.DedDescription;
                this.dollSelectTransfer.DlpID = this.dollTransfer;
            },
            clearSelection() {
                this.TypeSend = 0;
                this.tableSelect = {};
                this.dollSelectTransfer = {};
                console.log('clearSelection', this.TypeSend);
            },
            resetSelect() {
                this.TypeSend = 0;
                this.itemObservation = {
                    DlpTypeDiscard: 3,
                    DlpWeight: 0
                };
                this.refreshTabs = false;
                setTimeout(() => this.refreshTabs = true, 0);
            },

            CloseDialogInfoTable() {
                this.dialog = false;
                this.$emit("CloseDialogInfoTable");
            },
            refreshlines() {
                this.$emit("refreshlines");
            },

            async GetDollByTable() {
                try {
                    const { data, status } = await _dollTableService.list({
                        CttID: this.CttID,
                        ClpID: this.filter.ClpID,
                        DtbStatus: 2
                    }, this.$fun.getUserID());

                    if (status === 200) {
                        this.detailsDoll = data;
                    }
                } catch (error) {
                    console.error("Failed to fetch doll details:", error);
                }
            },

            DollTransferAction()
            {
                console.log("this.TypeSend", this.TypeSend);
                if(this.QuantityJabasTransfer == 0 || this.QuantityJabasTransfer == "")
                {
                    this.$fun.alert("El numero de jabas debe ser mayor a 0","warning");
                    return;
                }

                if(this.TypeSend == 0){
                    this.$fun.alert("Debe seleccionar un destino","warning");
                    return;
                }

                this.$fun.alert("¿Seguro de transferir?", "question")
                .then(r =>{
                    if(r.value)
                    {
                        console.log(this.TypeSend, this.tableSelect);
                        if(this.TypeSend == 1)
                        {
                            if(this.itemHead.DlpCodBase == ''){
                                this.$fun.alert("Ingrese codigo de base","warning");
                                this.$refs.txtDlpCodBase.focus();
                                return
                            }

                            this.stageTransfer = 2;
                            Object.assign(this.dollSelectTransfer, this.tableSelect)
                            this.dollSelectTransfer.IsTransfer = this.IsTransfer;
                            this.dollSelectTransfer.DlpQuantity = this.QuantityJabasTransfer;
                            this.dollSelectTransfer.DlpIDTransfer = this.dollSelectTransfer.DlpID;
                            this.dollSelectTransfer.CttIDTransfer =  this.CttID;
                            this.dollSelectTransfer.UsrCreateID = this.$fun.getUserID();
                            this.dollSelectTransfer.UsrUpdateID = this.$fun.getUserID();
                            this.dollSelectTransfer.DtbID = 0;
                            this.dollSelectTransfer.ClpIDX = this.tableSelect.ClpID;
                            this.dollSelectTransfer.ClpIDOrigin =this.filter.ClpID;
                            this.dollSelectTransfer.DlpCodBase = this.itemHead.DlpCodBase;

                            console.log(this.dollSelectTransfer);
                            _dollTableService
                            .save(this.dollSelectTransfer, this.$fun.getUserID())
                            .then(resp => {
                                if(resp.status == 200)
                                {
                                    this.$fun.alert("Transferido Correctamente", "success");
                                    this.ClearFormTransfer();
                                    this.CloseDialogInfoTable();
                                    this.RefreshStore();
                                    this.refreshlines();
                                }
                            })
                        }
                        else if(this.TypeSend == 2){

                            let processInitialData = localStorage.getItem('processInitialData');
                            processInitialData = JSON.parse(processInitialData);

                            this.dollSelectTransfer.DlpQuantity = this.QuantityJabasTransfer;
                            this.dollSelectTransfer.UsrCreateID = this.$fun.getUserID();
                            this.dollSelectTransfer.UsrUpdateID = this.$fun.getUserID();
                            this.dollSelectTransfer.DlpTypeDiscard = this.itemObservation.DlpTypeDiscard;
                            this.dollSelectTransfer.TrnID = processInitialData.TrnID;
                            this.dollSelectTransfer.TypeCultive = processInitialData.TypeCultive;
                            this.dollSelectTransfer.LncID = processInitialData.LncID;
                            this.dollSelectTransfer.DeleteRow = 0;

                            console.log(this.dollSelectTransfer);
                            _armedDoolService.savePosition( this.dollSelectTransfer, this.$fun.getUserID())
                            .then((r) => {
                                if (r.status == 200) {
                                    this.$fun.alert("Guardado correctamente", "success");
                                    this.ClearFormTransfer();
                                    this.CloseDialogInfoTable();
                                    this.RefreshStore();
                                    this.refreshlines();
                                }
                            })
                        }
                        else if(this.TypeSend == 3){
                            let data = this.dolls.length > 0 ? this.dolls[0] : null;
                            if(data == null){
                                this.$fun.alert("Error, algo salio mal","warning");
                                return
                            }
                            let item = {
                                QuantityJaba: data.DlpQuantity,
                                WeightJaba: data.AverageWeightJabaN,
                                TrnID: data.TrnID,
                                ClpID: data.ClpID,
                                TypeCultive: data.TypeCultive,
                                FsgTypeDiscart: data.DlpTypeDiscard,
                                TypeSelectionFrozen: data.TypeSelectionFrozen,
                                TypeFrozenCategory: data.TypeFrozenCategory,
                                TypeCrop: data.TypeCrop,
                                LncID: data.LncID,
                                VrtID: data.VrtID,
                                RcfID: data.RcfID,
                            };
                            _sFrzSelectionGreen.save(item, this.$fun.getUserID())
                            .then(resp => {
                                if(resp.status == 200)
                                {
                                    this.$fun.alert("Registrado en Selección Verde Correctamente", "success");

                                    let itemStore = {
                                        DlpQuantity: this.QuantityJabasTransfer,
                                        DlpID: data.DlpID,
                                        UsrCreateID: this.$fun.getUserID(),
                                        UsrUpdateID: this.$fun.getUserID(),
                                        DlpCodBase: data.DlpCodBase,
                                        DlpCol: data.DlpCol,
                                        DlpRow: data.DlpRow,
                                        LncID: data.LncID,
                                        DlpTypeDiscard: data.DlpTypeDiscard,
                                        DeleteRow: 1
                                    }

                                    _armedDoolService.savePosition( itemStore, this.$fun.getUserID())
                                    .then((r) => {
                                        if (r.status == 200) {
                                            this.$fun.alert("Guardado correctamente", "success");
                                            this.ClearFormTransfer();
                                            this.CloseDialogInfoTable();
                                            this.RefreshStore();
                                            this.refreshlines();
                                        }
                                    })
                                }
                            })
                        }
                        else if(this.TypeSend == 4){

                            this.dollSelectTransfer.DlpQuantity = this.QuantityJabasTransfer;
                            this.dollSelectTransfer.UsrCreateID = this.$fun.getUserID();
                            this.dollSelectTransfer.UsrUpdateID = this.$fun.getUserID();
                            this.dollSelectTransfer.DeleteRow = 0;
                            console.log("this.dollSelectTransfer", this.dollSelectTransfer);

                            _armedDoolService.saveDiscard(this.dollSelectTransfer, this.$fun.getUserID())
                            .then(resp => {
                                if(resp.status == 200)
                                {
                                    this.$fun.alert("Transferido Correctamente", "success");
                                    this.ClearFormTransfer();
                                    this.CloseDialogInfoTable();
                                    this.RefreshStore();
                                }
                            })
                        }
                    }
                });
            },

            ClearFormTransfer()
            {
                this.dollSelectTransfer = {};
                this.QuantityJabasTransfer = 0;
                this.dollTransfer = 0;
                this.tableSelect = {};
                this.stageTransfer = 1;
            },

            ShowViewDetails()
            {
                if(this.showMore)
                {
                    this.showMore = false;
                }else{
                    this.showMore = true;
                    this.GetDollByTable();
                }
            },
            RefreshStore(){
                this.$emit('RefreshStore');
            },
        },

        mounted () {
            if (this.dolls && this.dolls.length > 0) {
                console.log("this.dolls", this.dolls[0]);
                if (this.$route.path === '/produccioncongelados/armarmuneco' && this.dolls[0].DlpTypeDiscard == 2) {
                    this.selectDiscard = true;
                    this.selectGreen = false;
                }
            }
            if (this.$route.path === '/produccioncongelados/FrzCtnLinesProcess') {
                this.selectGreen = false;
            }
            this.$nextTick(() => {
                this.updateArrows();
            });
        },
        created()
        {
        },
    }
</script>

<style scoped>
/* ========== Dialog & Global ========== */
:deep(.doll-viewer-dialog) {
    border-radius: 16px !important;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
}

/* ========== Header ========== */
.viewer-header {
    background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
    padding: 14px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-title {
    color: white;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.3px;
}

/* ========== Body ========== */
.viewer-body {
    background: #fafbfc;
    max-height: calc(88vh - 60px);
    overflow-y: auto;
}

.viewer-stepper {
    background: transparent !important;
    box-shadow: none !important;
}

.stepper-header-compact {
    background: #fff;
    padding: 8px 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
    margin: 0;
}

.stepper-content-compact {
    padding: 12px 16px !important;
}

/* ========== Section Title ========== */
.section-title-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0 10px 0;
}

.title-left {
    display: flex;
    align-items: center;
    gap: 6px;
}

.section-label {
    font-size: 15px;
    font-weight: 600;
    color: #37474f;
}

.count-chip {
    font-weight: 700;
    height: 20px !important;
}

/* ========== Dolls Scroll Container ========== */
.dolls-scroll-container {
    display: flex;
    align-items: center;
    position: relative;
    margin: 0;
    width: 100%;
    min-width: 0;
}

/* ========== Scrollable Track ========== */
.dolls-scroll-track {
    flex: 1;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: visible;
    gap: 12px;
    padding: 16px 4px;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    min-width: 0;
}

.dolls-scroll-track::-webkit-scrollbar {
    display: none;
}

/* ========== Floating Navigation Arrows ========== */
.scroll-arrow {
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 1px solid rgba(25, 118, 210, 0.18);
    background: rgba(255, 255, 255, 0.82);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: 0 4px 16px rgba(25, 118, 210, 0.16), 0 0 0 1px rgba(255, 255, 255, 0.5) inset;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    margin: 0 2px;
}

.scroll-arrow:hover {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 6px 24px rgba(25, 118, 210, 0.28), 0 0 0 1px rgba(255, 255, 255, 0.7) inset;
    transform: scale(1.08);
    border-color: rgba(25, 118, 210, 0.35);
}

.scroll-arrow:active {
    transform: scale(0.95);
}

.scroll-arrow .v-icon {
    color: #1565c0 !important;
    font-size: 24px !important;
    filter: drop-shadow(0 1px 2px rgba(21, 101, 192, 0.2));
}

/* Edge state: semi-transparent but STILL VISIBLE */
.scroll-arrow.arrow-edge {
    opacity: 0.35;
    pointer-events: none;
}

.doll-slide-item {
    flex-shrink: 0;
    padding: 0;
}

/* ========== Doll Card ========== */
.doll-card {
    display: flex;
    flex-direction: column;
    height: 310px;
    border-radius: 14px !important;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    border: 2px solid transparent;
    background: #fff;
    overflow: hidden;
    user-select: none;
}

.doll-card.doll-selected {
    border-color: #1976d2;
    box-shadow: 0 4px 16px rgba(25, 118, 210, 0.22) !important;
    background: #f5f9ff;
}

/* -- Card Top (radio + id) -- */
.doll-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 8px 0 8px;
}

.doll-radio {
    margin: 0;
    padding: 0;
    transform: scale(0.85);
}

.doll-radio :deep(.v-radio) {
    margin: 0;
    padding: 0;
}

.doll-radio :deep(.v-input__control) {
    margin: 0;
}

.doll-id-badge {
    font-size: 13px;
    font-weight: 700;
    color: #1565c0;
    background: #e3f2fd;
    padding: 2px 8px;
    border-radius: 20px;
}

/* -- Image -- */
.doll-image-wrapper {
    padding: 2px 8px;
    flex-shrink: 0;
}

.doll-image {
    border-radius: 8px;
    background: #f5f5f5;
}

/* -- Info -- */
.doll-info {
    flex: 1;
    padding: 6px 10px;
    display: flex;
    flex-direction: column;
    gap: 3px;
    justify-content: center;
}

.info-row {
    display: flex;
    align-items: center;
    gap: 5px;
    line-height: 1.3;
}

.info-value {
    font-size: 11px;
    color: #546e7a;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.info-category {
    color: #1565c0;
    font-weight: 600;
}

/* -- Footer -- */
.doll-card-footer {
    padding: 6px 10px 10px 10px;
    display: flex;
    justify-content: center;
}

/* ========== Actions ========== */
.viewer-actions {
    display: flex;
    align-items: center;
    padding: 10px 0 0 0;
}
</style>
